import './raw_html.tag'
import makeResponsive from '../utils/tags/setup_responsive_tag.js'

riot.tag2('riot-annotation', '<raw-html content="{opts.content}"></raw-html>', '', 'class="simple-charts__annotation" riot-style="{position}"', function(opts) {

  makeResponsive(this)

});



/** WEBPACK FOOTER **
 ** ./src/components/annotations.tag
 **/